import { render } from "./ics_o_wallet.vue?vue&type=template&id=3b37f2b5&ts=true"
import script from "./ics_o_wallet.vue?vue&type=script&lang=ts"
export * from "./ics_o_wallet.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__